"use client";
import UserCircleIcon from "@heroicons/react/24/outline/UserCircleIcon";
import UserPlusIcon from "@heroicons/react/24/outline/UserPlusIcon";
import { useSideBarAuthModal } from "@/hooks/useSideBarAuthModal";

export function SidebarButtons({
  update,
  onClose,
}: {
  update: VoidFunction;
  onClose: () => void;
}) {
  const { setOpenedModal } = useSideBarAuthModal();

  const handleClick = (action: "login" | "register") => {
    onClose();
    setOpenedModal(action);
  };

  return (
    <div className="flex gap-4 w-full justify-between items-center flex-wrap">
      <button
        onClick={() => handleClick("register")}
        className="cursor-pointer flex items-center gap-2 px-2 py-2"
      >
        <UserPlusIcon className="size-6 text-secondary" />
        <span className="text-secondary text-[14px] font-semibold">
          Kayıt Olun
        </span>
      </button>

      <button
        onClick={() => handleClick("login")}
        className="cursor-pointer flex items-center gap-2 px-2 py-2"
      >
        <UserCircleIcon className="size-6" />
        <span className="text-[14px] font-semibold">Oturum Açın</span>
      </button>
    </div>
  );
}
